// Events list without prefix
// http://eonasdan.github.io/bootstrap-datetimepicker/Events/
export default [
  'hide', 'show', 'change', 'error', 'update'
]
